// assets/keuzehulp.js — plain script (defer), leest config uit window.KH_CONFIG (geen ES-module import; scoreboard-patroon)
(function () {
var QUIZ = (window.KH_CONFIG || {}).QUIZ;
var nextStep = (window.KH_CONFIG || {}).nextStep;
if (!QUIZ) { return; }

// GA4 / dataLayer event (no-op als geen analytics geladen).
function ghit(name, params) {
  try {
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params || {}));
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  } catch (e) {}
}

function KH(root) {
  this.root = root;
  this.i18n = JSON.parse(root.querySelector('[data-kh-i18n]').textContent);
  var imgEl = root.querySelector('[data-kh-img]');
  this.imgs = imgEl ? JSON.parse(imgEl.textContent) : {};
  this.flow = null; this.stepId = null; this.history = []; this.answers = [];
  this.qEl = root.querySelector('[data-kh-question]');
  this.aEl = root.querySelector('[data-kh-answers]');
  this.progressEl = root.querySelector('[data-kh-progress]');
  this.init();
}
KH.prototype.init = function () {
  var self = this;
  this.root.querySelectorAll('[data-kh-hub]').forEach(function (b) {
    b.addEventListener('click', function () { self.startFlow(b.getAttribute('data-kh-hub')); });
  });
  this.root.querySelector('[data-kh-back]').addEventListener('click', function () { self.back(); });
  // Opnieuw-knoppen (in elk resultaatscherm) → terug naar de hub.
  this.root.querySelectorAll('[data-kh-restart]').forEach(function (b) {
    b.addEventListener('click', function () { self.reset(); });
  });
  // ATC vanuit een resultaatkaart → cart-attribute + GA4-event.
  this.root.querySelectorAll('[data-kh-atc]').forEach(function (f) {
    f.addEventListener('submit', function () {
      var src = (f.querySelector('[name="properties[_keuzehulp]"]') || {}).value || '';
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { keuzehulp: src } })
        });
      } catch (e) {}
      ghit('keuzehulp_add_to_cart', { source: src });
    });
  });
  // Pro-bags: speed-sliders → live herfilteren.
  this.root.querySelectorAll('[data-kh-speed-sliders] input').forEach(function (inp) {
    inp.addEventListener('input', function () {
      var block = inp.closest('[data-kh-result]');
      if (block) self.applyProFilter(block);
    });
  });
  // Context-instap via section-settings of URL-params
  var params = new URLSearchParams(location.search);
  var startFlow = this.root.getAttribute('data-start-flow') || params.get('flow');
  if (startFlow) this.startFlow(startFlow);
};
KH.prototype.reset = function () {
  this.flow = null; this.flowId = null; this.stepId = null; this.history = []; this.answers = [];
  this.show('hub');
};
KH.prototype.show = function (name) {
  this.root.querySelectorAll('.kh__screen').forEach(function (s) { s.classList.remove('is-active'); });
  var el = this.root.querySelector('[data-kh-screen="' + name + '"]');
  if (el) el.classList.add('is-active');
  try { this.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
};
KH.prototype.startFlow = function (flowId) {
  this.flow = QUIZ.flows[flowId]; if (!this.flow) return;
  this.flowId = flowId; this.answers = []; this.history = [];
  this.stepId = this.flow.start; this.show('question'); this.render();
  ghit('keuzehulp_start', { flow: flowId });
};
// Shopify's | t-filter HTML-escapet vertalingen ('->&#39; & ->&amp;); decodeer vóór textContent.
function decodeEntities(s) { var t = document.createElement('textarea'); t.innerHTML = (s == null ? '' : String(s)); return t.value; }

KH.prototype.render = function () {
  var self = this, step = this.flow.steps[this.stepId], dict = this.i18n[step.key];
  this.qEl.textContent = decodeEntities(dict.q);
  this.aEl.innerHTML = '';
  var imgMap = self.imgs[step.key] || {};
  step.answers.forEach(function (ans) {
    var btn = document.createElement('button');
    btn.className = 'kh__card';
    var url = imgMap[ans.id];
    if (url) {
      var im = document.createElement('img');
      im.src = url; im.alt = ''; im.loading = 'lazy';
      btn.appendChild(im);
    } else {
      btn.classList.add('kh__card--noimg');
    }
    var label = document.createElement('span');
    label.className = 'kh__card-label';
    label.textContent = decodeEntities(dict[ans.id]);
    btn.appendChild(label);
    btn.addEventListener('click', function () { self.answer(ans.id); });
    self.aEl.appendChild(btn);
  });
  var depth = this.history.length + 1;
  this.progressEl.style.width = Math.min(100, depth * 25) + '%';
};
KH.prototype.answer = function (answerId) {
  ghit('keuzehulp_step', { flow: this.flowId, step: this.stepId, answer: answerId });
  this.answers.push({ step: this.stepId, answer: answerId });
  var res = nextStep(this.flowId, this.stepId, answerId);
  if (!res) return;
  if (res.outcome) { this.showResult(res.outcome); return; }
  this.history.push(this.stepId); this.stepId = res.step; this.render();
};
KH.prototype.back = function () {
  if (!this.history.length) { this.show('hub'); return; }
  this.answers.pop(); this.stepId = this.history.pop(); this.render();
};
KH.prototype.showResult = function (outcomeId) {
  ghit('keuzehulp_result', { flow: this.flowId, outcome: outcomeId });
  // Onthul vooraf-gerenderd resultaatblok [data-kh-result="<id>"].
  var block = this.root.querySelector('[data-kh-result="' + outcomeId + '"]');
  if (block) {
    this.fillWhyChips(block);
    if (outcomeId === 'bags_pro' || outcomeId === 'bags_pro_carpet') this.filterProBags(block);
    this.show('result-' + outcomeId);
  }
  else if (this.progressEl) { this.progressEl.style.width = '100%'; }
};
// Onthoud de gekozen worp-type en pas het pro-filter (worp + speed-sliders) toe.
KH.prototype.filterProBags = function (block) {
  this._worp = '';
  for (var i = 0; i < this.answers.length; i++) { if (this.answers[i].step === 'pro_worp') { this._worp = this.answers[i].answer; break; } }
  this.applyProFilter(block);
};
// Filter pro-bags op worp-type (tag) + speed-sliders (fast ≥ min, slow ≤ max). Fallback: laat speed los.
KH.prototype.applyProFilter = function (block) {
  var worpTag = this._worp ? ('worp-' + this._worp.replace(/_/g, '-')) : '';
  var sl = block.querySelector('[data-kh-speed-sliders]');
  var fastMin = 1, slowMax = 10;
  if (sl) {
    var fm = sl.querySelector('[data-kh-fast-min]'); if (fm) fastMin = parseInt(fm.value, 10) || 1;
    var sm = sl.querySelector('[data-kh-slow-max]'); if (sm) slowMax = parseInt(sm.value, 10) || 10;
    var fo = sl.querySelector('[data-kh-fast-out]'); if (fo) fo.textContent = fastMin;
    var so = sl.querySelector('[data-kh-slow-out]'); if (so) so.textContent = slowMax;
  }
  var cards = Array.prototype.slice.call(block.querySelectorAll('[data-kh-fast]'));
  var MAX = 8, shown = 0;
  cards.forEach(function (c) {
    var fast = parseInt(c.getAttribute('data-kh-fast'), 10) || 0;
    var slow = parseInt(c.getAttribute('data-kh-slow'), 10) || 0;
    var worps = c.getAttribute('data-kh-worp') || '';
    var okWorp = !worpTag || worps.indexOf(worpTag) !== -1;
    var okSpeed = fast >= fastMin && (slow === 0 || slow <= slowMax);
    if (okWorp && okSpeed && shown < MAX) { c.hidden = false; shown++; } else { c.hidden = true; }
  });
  var none = block.querySelector('[data-kh-pro-none]');
  if (shown === 0) {
    // Geen strikte match → melding bovenaan tonen + (indien mogelijk) de dichtstbijzijnde bags op worp.
    if (cards.length) {
      var count = 0;
      cards.forEach(function (c) {
        var worps = c.getAttribute('data-kh-worp') || '';
        var okWorp = !worpTag || worps.indexOf(worpTag) !== -1;
        if (okWorp && count < MAX) { c.hidden = false; count++; } else { c.hidden = true; }
      });
      if (count === 0) cards.forEach(function (c, i) { c.hidden = i >= MAX; });
    }
    if (none) none.hidden = false;
  } else if (none) { none.hidden = true; }
};
// Toon de gekozen antwoorden als chips onder de "waarom past dit"-regel (specifieker dan de algemene zin).
KH.prototype.fillWhyChips = function (block) {
  var self = this;
  var why = block.querySelector('.kh__why');
  if (!why) return;
  var old = block.querySelector('.kh__why-chips');
  if (old) old.parentNode.removeChild(old);
  var labels = this.answers.map(function (a) {
    var step = self.flow && self.flow.steps[a.step];
    var key = step ? step.key : a.step;
    var d = self.i18n[key]; return d ? decodeEntities(d[a.answer]) : '';
  }).filter(Boolean);
  if (!labels.length) return;
  var wrap = document.createElement('div');
  wrap.className = 'kh__why-chips';
  labels.forEach(function (l) {
    var c = document.createElement('span'); c.className = 'kh__why-chip'; c.textContent = l; wrap.appendChild(c);
  });
  why.parentNode.insertBefore(wrap, why.nextSibling);
};
document.querySelectorAll('[data-kh]').forEach(function (r) { new KH(r); });
})();
